import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    .nextStepButton {
        height: 45px;
        font-size: 14px;
        color: white;
        font-weight: bold;
        font-family: 'Open Sans', sans-serif;
        padding: 22.5px;
        border-radius: 6px;
        background-color: ${props => props.theme.primary};
        border-color: ${props => props.theme.primary};
        transition: all 200ms ease 0s;
        line-height: 0;
        width: 100%;
        position: relative;
        cursor: pointer;
        margin-top: 10px;
    }

    .loader-inner {
        margin-top: 10px;
    }

    .error {
        color: ${props => props.theme.errorColor};
        margin-top: 10px;
        text-align: center;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/ButtonContainerStyle.js